<div
  class="tile"
  [style.padding]="tile().extension ? '8px 8px 0px 8px' : '8px'"
  [style.grid-template-rows]="
    tile().extension ? 'max-content max-content max-content' : '1fr'
  "
>
  <div class="main">
    @if (!!tile().innerMap) {
      <pozi-google-maps
        [input]="tile().innerMap!"
        [isBackToOverviewButtonEnabled]="false"
        [mapOptionsOverride]="nonInteractiveGoogleMapsOptions"
      ></pozi-google-maps>
    }

    <div class="column" [style.grid-template-rows]="columnGridTemplateRows()">
      <div class="header">
        <div class="title">
          <span class="label">{{ tile().title }}</span>
          @if (tile().subtitle) {
            <span class="subtitle">{{ tile().subtitle }}</span>
          }
        </div>

        @if (tile().primaryValue) {
          <div class="primary-value">
            <ng-container
              *ngTemplateOutlet="
                valueTemplate;
                context: { value: tile().primaryValue }
              "
            ></ng-container>
          </div>
        }
      </div>

      @if (tile().progressBar) {
        <div
          class="progress-bar"
          poziOverlay
          [template]="
            progressBar().length > 1 ? progressBarTooltipTemplate : undefined
          "
          [templateContext]="{ progressBar: progressBar() }"
          [cdkOverlayPositionPairs]="cdkOverlayPositionPairs"
        >
          @for (bar of progressBar(); track $index) {
            <div
              class="inner-progress-bar"
              [style.width.%]="bar?.value"
              [style.background-color]="bar?.color ?? ''"
            ></div>
          }
        </div>
      }

      @if (tile().secondaryValues && tile().secondaryValues?.length) {
        <div class="secondary-values">
          <ng-container
            *ngTemplateOutlet="
              valuesTemplate;
              context: {
                values: tile().secondaryValues,
              }
            "
          ></ng-container>
        </div>
      }
    </div>

    @if (tile().nav && !!tile().nav?.routerLink && !clickableTile()) {
      <a
        class="action"
        [routerLink]="tile().nav?.routerLink"
        [queryParams]="tile().nav?.queryParams"
      >
        <i
          class="material-symbols-rounded wght-200"
          [style.transform]="'rotate(135deg)'"
          >arrow_back_ios</i
        >
      </a>
    }
  </div>

  @if (tile().extension) {
    <div class="gap"></div>
    <div
      class="extension"
      poziScrollFade
      [scrollFadeDisabled]="limitExtension()"
      [class.limited]="limitExtension()"
    >
      @for (line of displayedExtension(); track line) {
        <div class="extension-line">
          <ng-container
            *ngTemplateOutlet="valuesTemplate; context: { values: line }"
          ></ng-container>
        </div>
      }
    </div>
  }

  @if (clickableTile() && !!tile().nav?.routerLink) {
    <a
      class="tile-link"
      [routerLink]="tile().nav?.routerLink"
      [queryParams]="tile().nav?.queryParams"
      [attr.aria-label]="tile().title"
    ></a>
  }
</div>

<ng-template #valuesTemplate let-values="values">
  @for (value of values; track $index) {
    <div class="value-wrapper">
      <ng-container
        *ngTemplateOutlet="valueTemplate; context: { value }"
      ></ng-container>
    </div>
  }
</ng-template>

<ng-template #valueTemplate let-value="value">
  @if (value.hasOwnProperty('label')) {
    <span class="label">{{ value.label }} </span>
  }

  @if (value.hasOwnProperty('text')) {
    @if (value.text === null) {
      <ng-container *ngTemplateOutlet="placeholderValueTemplate"></ng-container>
    } @else {
      <span
        class="value"
        [style.color]="value.color ?? ''"
        [style.font-size]="value.fontSize ? value.fontSize + 'px' : ''"
      >
        <span class="text" [style.font-size]="'inherit'">{{ value.text }}</span>
        @if (value.subText) {
          <span class="sub-text" [style.font-size]="'inherit'">{{
            value.subText
          }}</span>
        }
      </span>
    }
  } @else if (value.hasOwnProperty('number')) {
    @if (value.number === null) {
      <ng-container *ngTemplateOutlet="placeholderValueTemplate"></ng-container>
    } @else {
      <span
        class="value"
        [style.color]="value.color ?? ''"
        [style.font-size]="value.fontSize ? value.fontSize + 'px' : ''"
      >
        {{ value.prefix ?? '' }}{{ value.number | formatNumber: 0 : 2
        }}{{ value.unit ?? '' | formatUnit }}
      </span>
    }
  } @else if (value.hasOwnProperty('array')) {
    @if (value.array === null) {
      <ng-container *ngTemplateOutlet="placeholderValueTemplate"></ng-container>
    } @else {
      <span
        class="value"
        [style.color]="value.color ?? ''"
        [style.font-size]="value.fontSize ? value.fontSize + 'px' : ''"
      >
        @for (str of value.array; track str) {
          {{ str }}
          @if (!$last) {
            <span class="dark-gray" [style.font-weight]="400">{{
              value.separator ?? '/'
            }}</span>
          }
        }
      </span>
    }
  } @else if (value.hasOwnProperty('date')) {
    @if (value.date === null) {
      <ng-container *ngTemplateOutlet="placeholderValueTemplate"></ng-container>
    } @else {
      <span
        class="value"
        [style.color]="value.color ?? ''"
        [style.font-size]="value.fontSize ? value.fontSize + 'px' : ''"
        >{{ value.date | formatDate: value.dateFormat : true }}</span
      >
    }
  } @else if (value.hasOwnProperty('date1') && value.hasOwnProperty('date2')) {
    @if (value.date1 === null && value.date2 === null) {
      <ng-container *ngTemplateOutlet="placeholderValueTemplate"></ng-container>
    } @else {
      <span
        class="value"
        [style.color]="value.color ?? ''"
        [style.font-size]="value.fontSize ? value.fontSize + 'px' : ''"
      >
        {{ value.date1 | formatDate: value.date1Format : true }}
        {{ value.separator ?? '-' }}
        {{ value.date2 | formatDate: value.date2Format : true }}
      </span>
    }
  } @else if (value.hasOwnProperty('symbol')) {
    <pozi-symbol [matSymbol]="value"></pozi-symbol>
  } @else if (value.hasOwnProperty('icon')) {
    <pozi-icon [icon]="value"></pozi-icon>
  }
</ng-template>

<ng-template #placeholderValueTemplate>
  <span class="value placeholder" i18n> N/A </span>
</ng-template>

<ng-template #progressBarTooltipTemplate let-progressBar="progressBar">
  <div
    class="tooltip"
    [class.tooltip-block]="progressBar && progressBar.length"
  >
    @for (item of progressBar; track $index) {
      <div class="tooltip-item">
        <div class="bar-icon" [style.background-color]="item.color"></div>
        <div>
          <b>{{ item.name }}:</b> {{ item.value }}%
        </div>
      </div>
    }
  </div>
</ng-template>
